export default __webpack_public_path__ + "static/media/august.bd3f8184.jpg";